import { render, staticRenderFns } from "./COMPANY_HOME.vue?vue&type=template&id=5fe1bf48&scoped=true"
import script from "./COMPANY_HOME.vue?vue&type=script&lang=ts"
export * from "./COMPANY_HOME.vue?vue&type=script&lang=ts"
import style0 from "./COMPANY_HOME.vue?vue&type=style&index=0&id=5fe1bf48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe1bf48",
  null
  
)

export default component.exports